export const UTILITIES_LIST = [
    {
        link: '/tien-ich-thoi-tiet.epi',
        name: 'Thời tiết',
        icon: 'uti-1',
        shortName: 'widget-weather',
    },
    {
        link: '/tien-ich-ty-gia-ngoai-te.epi',
        name: 'Tỷ giá ngoại tệ',
        icon: 'uti-2',
        shortName: 'widget-currency',
    },
    {
        link: '/tien-ich-gia-vang.epi',
        name: 'Giá vàng',
        icon: 'uti-3',
        shortName: 'widget-gold',
    },
    {
        link: '/tien-ich-ket-qua-xo-so.epi',
        name: 'Kết quả xổ số',
        icon: 'uti-4',
        shortName: 'widget-lottery',
    },
    {
        link: '/tien-ich-gia-chung-khoan.epi',
        name: 'Chứng khoán',
        icon: 'uti-5',
        shortName: 'widget-stock',
    },
    {
        link: '/tien-ich-lich-truyen-hinh.epi',
        name: 'Lịch truyền hình',
        icon: 'uti-6',
        shortName: 'widget-tvschedule',
    },
    {
        link: '/tien-ich-tu-vi-cung-hoang-dao.epi',
        name: 'Cung hoàng đạo',
        icon: 'uti-8',
        shortName: 'widget-horoscope',
    },
    {
        link: '/tien-ich-gia-xang-dau.epi',
        name: 'Giá xăng dầu',
        icon: 'uti-9',
        shortName: 'widget-petrol',
    },
    {
        link: '/tien-ich-bang-gia-xe-o-to.epi',
        name: 'Giá xe ô tô',
        icon: 'uti-10',
        shortName: 'widget-vehicle',
    },
    {
        link: '/tien-ich-bang-gia-xe-xe-may.epi',
        name: 'Giá xe máy',
        icon: 'uti-11',
        shortName: 'widget-vehicle-bike',
    },
    {
        link: '/tien-ich-lich-van-nien.epi',
        name: 'Lịch vạn niên',
        icon: 'uti-12',
        shortName: 'widget-calendar',
    },
    {
        link: '/bong-da/livescore.epi',
        name: 'Kết quả bóng đá',
        icon: 'uti-13',
        shortName: 'widget-soccer',
    },
];
